/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC } from 'react';
import { useTranslations } from 'next-intl';
import { useDispatch } from 'react-redux';
import { AuthDecorator } from '@components/auth-decorator';
import { Button } from '@components/design-system';
import { actions } from '@state/modals';

interface IOffer {
  tokenKT?: string;
  tokenId: number;
}

export const Offer: FC<IOffer> = ({ tokenKT, tokenId }) => {
  const t = useTranslations('market');
  const dispatch = useDispatch();

  const handleCreateOffer = () => {
    dispatch({
      type: actions.MODALS_SET_MODAL,
      payload: { type: 'offer-create', tokenKT, tokenId },
    });
  };

  return (
    <AuthDecorator onClick={handleCreateOffer}>
      <Button full variant="secondary">
        {t('offer')}
      </Button>
    </AuthDecorator>
  );
};
